(() => {

    const btnSearch = document.querySelector('.search-button')
    const searchContainer = document.querySelector('.search-container')

    if (!btnSearch) {
        return
    }

    const blur = searchContainer.querySelector('.blur')

    btnSearch.addEventListener('click', () => {
        searchContainer.classList.toggle('open')
    })


    //if window scroll, remove open
    window.addEventListener('scroll', () => {
        searchContainer.classList.remove('open')
    })

    //if click on blur, remove open
    blur.addEventListener('click', () => {
        searchContainer.classList.remove('open')
    })
    
})();